import React, { memo } from 'react'

import { func } from 'prop-types'

function ReferenceDropzone({ onBrowse }) {
  return (
    <button type="button" className="visual-references__dropzone" onClick={onBrowse}>
      <span className="visual-references__dropzone-title cgt-body-base-semibold">
        Drag reference images here
      </span>
      <span className="visual-references__dropzone-or cgt-caption">or</span>
      <span className="visual-references__dropzone-browse cgt-button-text-base-semibold">Browse</span>
    </button>
  )
}

ReferenceDropzone.propTypes = {
  onBrowse: func.isRequired,
}

export default memo(ReferenceDropzone)
